import { gql } from '@apollo/client/core';

export const createFacilitySignOutFromPhone = gql`
  mutation createFacilitySignOutFromPhone(
    $facilityId: String!
    $phoneNumber: String!
  ) {
    createFacilitySignOutFromPhone(
      facilityId: $facilityId
      phoneNumber: $phoneNumber
    )
  }
`;
